let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hhf8b")).then(() => parcelRequire('cDa2P'));